import { Separator } from "@/components/ui/separator";
import { Dot, EllipsisVertical, User, X } from "lucide-react";
import React, { useEffect, useState } from "react";
import FormInputField from "@/components/lib/from-input-field";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { toast } from "react-hot-toast";
import useAuth from "@/hooks/useAuth";
import { assignTable, createBookingTable, createRoom, createTable, getAllFloorsWithoutPagination, getAllRooms, getAllRoomsWithoutPagination, getAllTablesWithRoom, quickBookingTable, updateRoom, updateTable } from "@/api/table-floor/tableFloor";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllTables } from "@/redux/slice/table-slice/table-slice";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { getAllStaff } from "@/api/staff";
import { restaurant_id } from "@/api/lib/url";
import CustomerMultiSelect from "../loyalty/CustomerMultiSelect";
import StaffMultiSelect from "../common/StaffMultiSelect";
import { fetchAllStaff } from "@/redux/slice/staff-management/staff-attendance";
import { useNavigate } from "react-router-dom";

const addNewFloorCardSchema = z.object({
  floor_id: z.number().min(1, "Floor is required"),
  room_id: z.number().min(1, "Room is required"),
  // table_id: z.number().min(1, "Table is required"),
  // table_id: z.preprocess(
  //   (val) => {
  //     if (val === "" || val === undefined) return "";
  //     return Number(val);
  //   },
  //   z.union([z.number(), z.literal("")])
  // ).optional(),
  table_ids: z.array(z.number()).optional(),
  // guest: z.coerce.number().min(1, "Guest is required"),
  // reservation_type: z.string().min(1, "Reservation type is required"),
  // staff_id: z.coerce.number().optional(),
  // staff_id: z.preprocess(
  //   (val) => {
  //     if (val === "" || val === undefined) return "";
  //     return Number(val);
  //   },
  //   z.union([z.number(), z.literal("")])
  // ).optional(),

  // reservation_date: z.preprocess((val) => {
  //   if (!val) return undefined;
  //   const date = new Date(val);
  //   return date.toISOString().split("T")[0];
  // }, z.string({ required_error: "End date is required" })),
  // start_time: z.string().min(1, "Start time is required"),
  // end_time: z.string().min(1, "End time is required"),
  full_room_book: z.boolean().optional().default(false),
  // status: z.string().optional()
});

const AssignTableModal = ({ isOpen, onClose, singleReservation }) => {
  
  const { tables, selectedFloor, selectedRoom } = useSelector(
    (state) => state.table.table
  );
  const { staffList } = useSelector(
      (state) => state.staffManage.attendance
    );
  const [loading, setLoading] = useState(false);
  const [showIsChild, setShowIsChild] = useState(false);
  const { user } = useAuth();
  const [selectedUser, setSelectedUser] = useState([]);
  const [customer, setCustomer] = useState([])
  const [floors, setFloors] = useState([])
  const [rooms, setRooms] = useState([])
  // console.log(selectedUser)
  
  const [selectedPayerUser, setSelectedPayerUser] = useState([]);
  const dispatch = useDispatch();  
  const navigate = useNavigate();

  const form = useForm({
    resolver: zodResolver(addNewFloorCardSchema),
    mode: "onChange",
    defaultValues: {
      floor_id: "",
      room_id: "",
      table_id: "",
      table_ids: [],
      // guest: singleReservation?.guest,
      // reservation_type: singleReservation?.reservation_type,
      // staff_id: "",
      // reservation_date: "",
      // start_time: "",
      // end_time: "",
      // status: "",
      full_room_book: false,
    },
  });
  // console.log(form.formState.errors);
  useEffect(() => {
    if (!isOpen) return;
    if (user?.restaurant_id) {
      getAllFloorsWithoutPagination(user.restaurant_id)
        .then((res) => {
          if (res.status === "success") {
            setFloors(res.data.floors);
          }
        })
        .catch((err) => console.log(err));
    }
    form.reset(form.defaultValues);
  }, [isOpen, user?.restaurant_id]);

  useEffect(() => {
    if (showIsChild && staffList.length === 0) {
      dispatch(fetchAllStaff());
    }
  }, [showIsChild])
  

  const floorId = form.watch("floor_id");
  const [roomReset, setRoomReset] = useState(false)
  useEffect(() => {
    if(floorId){
      getAllRoomsWithoutPagination(user?.restaurant_id, floorId)
        .then((res) => {
          if (res.status === "success") {
            if(roomReset) {
              form.setValue("room_id", "");
            }
            setRooms(res.data.rooms);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [floorId]);

  const roomId = form.watch("room_id");
  useEffect(() => {
    if(roomId){
      // getAllTablesWithRoom(roomId)
      //   .then((res) => {
      //     if (res.status === "success") {
      //       setTables(res.data.tables);
      //     }
      //   })
      //   .catch((err) => console.log(err));
      dispatch(fetchAllTables(Number(roomId)));
    }
  }, [roomId]);

  const { reset } = form;
  const addFloorCardData = async (data) => {
    if(showIsChild && selectedUser.length < 1) {
      toast.success("Assign staff is required");
      return
    }
    setLoading(true);
    const payload =
      {
        ...data,
        restaurant_id: user.restaurant_id,
        // customer_name: singleReservation?.customer?.full_name,
        // customer_phone: singleReservation?.customer?.number,
        // reservation_date: singleReservation?.reservation_date?.split('T')[0],
        // start_time: singleReservation?.start_time?.split(':').slice(0, 2).join(':'),
        // end_time: singleReservation?.end_time?.split(':').slice(0, 2).join(':'),
        // advance: singleReservation?.advance || 0,
        // note: singleReservation?.note || "",
        staff_id: showIsChild ? selectedUser[0]?.id :  "",
      };
    if (data.full_room_book) {
      delete payload.table_ids;
      payload.staff_id = "";
    }
    try {
      let res;
      // if(data.full_room_book) {
      //   res = await createBookingTable(payload);
      // } else {
        res = await assignTable(singleReservation.id, payload);
      // }
      if (res.status === "success") {
        toast.success("Booked Table successfully!");
        // navigate("/table")
        onClose();
        reset();
        window.location.reload();
        // IMPORTANT: refresh tables for selected room to reflect changes immediately
        // if (data.room_id || selectedRoom?.id) {
        //   const roomId = data.room_id || selectedRoom?.id;
        //   dispatch(fetchAllTables(Number(roomId)));
        // }
      } else {
        toast.error(res.message || "Something went wrong!");
      }
    } catch (err) {
      toast.error(err?.message || "Failed to process Floor Card");
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);

    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, "0");
    const dd = String(date.getUTCDate()).padStart(2, "0");

    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    });

    return `${yyyy}-${mm}-${dd} ${time}`;
  };

  const isFullRoomBook = form.watch("full_room_book");

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
        <Card className="bg-cblack4 text-cwhite w-[550px] overflow-scroll">
          <CardHeader className="flex flex-row justify-between items-center">
            <CardTitle className="text-cwhite text-xl font-medium">Assign Table</CardTitle>
            <X onClick={()=>{onClose(); setRoomReset(false)}} className="cursor-pointer" size={16} />
          </CardHeader>
          <Separator />
          <CardContent>
            <div className="mt-8">
              <Form {...form}>
                <form onSubmit={form.handleSubmit(addFloorCardData)} className="flex flex-col gap-5">
                  <div onClick={()=>setRoomReset(true)}>
                    <FormInputField
                      name="floor_id"
                      style="bg-cblack3"
                      placeholder={"Select Floor"}
                      form={form}
                      type="select"
                      parseAs="string"
                      selectOption={floors?.map(item => ({
                        label: item.name,
                        value: item.id,
                      }))}
                      label={"Floor"}
                      required={true}
                    />
                  </div>
                  <FormInputField
                    name="full_room_book"
                    form={form}
                    type="checkbox"
                    style="bg-cblack3"
                    label={"Full Room Book"}
                  />
                  <FormInputField
                    name="room_id"
                    style="bg-cblack3"
                    placeholder={"Select Room"}
                    form={form}
                    type="select"
                    parseAs="string"
                    selectOption={rooms?.map(item => ({
                      label: item.name,
                      value: item.id,
                    }))}
                    label={"Room"}
                    required={true}
                  />
                  {
                    !isFullRoomBook && 
                    <>
                      <FormInputField
                        name="table_ids"
                        style="bg-cblack3"
                        placeholder={"Select Table"}
                        form={form}
                        type="multiselect"
                        label={"Table Name / Number"}
                        // parseAs="string"
                        selectOption={tables?.map(item => ({
                          label: item.name,
                          value: item.id,
                        }))}
                        required={true}
                      />
                    </>
                  }
                  <div className="grid grid-cols-2 gap-4">
                    {/* <div>
                      <FormInputField
                        name="reservation_type"
                        style="bg-cblack3"
                        placeholder={"Reservation Type*"}
                        form={form}
                        type="select"
                        parseAs="string"
                        selectOption={[
                          { label: "In Person", value: "in_person" },
                          { label: "Phone Call", value: "phone" },
                          { label: "Online", value: "online" },
                          { label: "Other", value: "other" },
                        ]}
                        label={"Reservation Type"}
                        required={true}
                      />
                    </div> */}
                    {!isFullRoomBook &&
                      <div className="space-y-2">
                        <div className="flex gap-2 items-center">
                          <Switch
                            className="data-[state=unchecked]:bg-neutral-500"
                            checked={showIsChild}
                            onCheckedChange={(val) => setShowIsChild(val)}
                          />
                          <Label>Assign Staff</Label>
                        </div>
        
                        {showIsChild && (
                          <StaffMultiSelect
                            options={staffList}
                            value={selectedUser}
                            onChange={setSelectedUser}
                          />
                        )}
                      </div>
                    }
                  </div>
                  
                  <div className="mt-4 flex gap-5 w-full">
                    <Button type="button" className="w-full bg-cred text-white" onClick={onClose}>
                        Cancel
                    </Button>

                    <Button type="submit" isLoading={loading} className="w-full bg-cyellow">
                        Confirm
                    </Button>
                  </div>
                </form>
              </Form>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default AssignTableModal;
